<template>
  <div>
    <dialogos-app :dialogos="dialogos" @update:currentText="currentText = $event, $refs.audioPlayer.playAudio($event)"></dialogos-app>
    <v-layout wrap justify-center>
      <v-flex xs12 md6 v-for="i in 2" :key="'button'+i">
        <div class="card-container">
          <transition name="custom" enter-active-class="animated flipInY" leave-active-class="animated flipOutY" mode="out-in">
            <svg-buttons :active="currentText==1" :key="vistos[i-1]" v-if="!vistos[i-1]" :buttonId="i" @mostrar="$set(vistos,$event - 1,true) " class="pa-2 svg-carg"></svg-buttons>
            <p :key="'t1'" v-if="vistos[0] && i == 1" class="ma-2" :class="'text-'+i">
              <span>Debido a que las reservas y los recursos de un depósito no se pueden medir directamente, deben determinarse mediante el análisis 
              <v-tooltip top>
                <template v-slot:activator="{on}">
                  <span v-on="on" class="tooltip-activator activator-white">geológico</span>
                </template>
                <span><strong>Geología:</strong> Ciencia que estudia el origen, formación y evolución de la Tierra, así como su estructura y los materiales que a componen.</span>
              </v-tooltip>
              y la
              <v-tooltip top>
                <template v-slot:activator="{on}">
                  <span v-on="on" class="tooltip-activator activator-white">Ingeniería de Yacimientos.</span>
                </template>
                <span><strong>Ingeniería de Yacimientos:</strong> Arte de desarrollar y explotar los yacimientos.</span>
              </v-tooltip>
              </span>
            </p>
            <p :key="'t2'" v-if="vistos[1] && i == 2" class="ma-2" :class="'text-'+i">
              <span>Por que las estimaciones de reservas y recursos de petróleo y gas tienen una 
                <v-tooltip top>
                  <template v-slot:activator="{on}">
                    <span v-on="on" class="tooltip-activator activator-black">incertidumbre intrínseca.</span>
                  </template>
                  <span><strong>Incertidumbre intrínseca:</strong>  Describe el rango de posibilidades de un estimado de recursos de hidrocarburos.</span>
                </v-tooltip>
              </span>
              </p>
          </transition>
        </div>
      </v-flex>
    </v-layout>
    
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 1/AUDIO 03',
    'Modulo 1/AUDIO 04',
    ]"></audio-player> 
  </div>
</template>

<script>
import svgButtons from '../../assets/Modulo 1/diapositiva-3'
export default {
  components: {
    svgButtons
  },
  data() {
    return {
      vistos: [false,false],
      currentText: 0,
      dialogos: [
        "¡Muy bien! Hemos mencionado el proceso de estimación de las reservas y los recursos, ¿por qué es necesario este proceso?",
        "Para promover la uniformidad y la medida estándar de los activos, ofreciendo una estructura para cuantificar el riesgo y la incertidumbre a través de su categorización. <span class='instruccion'>Haz clic en los botones.</span>"
      ],
      textos: [
        "Debido a que las reservas y los recursos de un depósito no se pueden medir directamente, deben determinarse mediante el análisis geológico y la Ingeniería de Yacimientos.",
        "Por que las estimaciones de reservas y recursos de petróleo y gas tienen una incertidumbre intrínseca."
      ]
    }
  },
  created() {
    this.$store.commit('nextShow', true)
  }
}
</script>
<style lang="scss" scoped>
.tooltip-activator.activator-white {
  color: white;
  border-color: white;
}
.tooltip-activator.activator-black {
  color: black;
  border-color: black;
  &:hover {
    color: white;
    border-color: white;
  }
}

.text-1, .text-2 {
  padding: 20px;
  min-height: 200px;
  display: flex;
  align-items: center;
}

.text-1{
  background-color: #004433;
  color: white;
}

.text-2 {
  background-color: #beeb7b;
}
</style>
